import { ObserverManager } from '@trimble/utilities/patterns';
import { ISessionEvent, SessionObserver } from './types';

/**
 * Session observer manager - specialized instance for session events
 * Wraps the generic ObserverManager from @trimble/utilities
 */
export class SessionObserverManager extends ObserverManager<ISessionEvent> {
  /**
   * Subscribe to session events
   */
  public override subscribe(observer: SessionObserver): () => void {
    return super.subscribe(observer);
  }

  /**
   * Unsubscribe from session events
   */
  public override unsubscribe(observer: SessionObserver): void {
    super.unsubscribe(observer);
  }
}

// Re-export ObserverManager for convenience
export { ObserverManager };
